<template>
  <div class="app">
    <form class="personal-form" action="" @submit.prevent="saveUserInfo">
      <scroll @refresh="refresh" class="" id="personal-scroll">
        <div class="mylogin">
          <div class="camera"></div>
          <div class="flex-item"></div>
          <div class="myphoto"></div>
        </div>
        <ul class="list list-personal">
          <li class="list-item person-show-click">
            <div class="f-minor item-left">姓名</div>
            <input
              v-if="!isTFY"
              type="text"
              class="ipt-inline person-input"
              :class="showInput == false ? 'person-hiden' : 'person-show'"
              id="person-input-name"
              style="background: #fff"
              v-model="saveInfo.name"
              placeholder="请输入用户姓名"
              maxlength="20"
              @focus="showInput = true"
            />
            <input
              v-else
              type="text"
              class="ipt-inline person-input"
              :class="showInput == false ? 'person-hiden' : 'person-show'"
              id="person-input-name"
              style="background: #fff"
              v-model="saveInfo.name"
              placeholder="请输入用户姓名"
              maxlength="20"
              readonly
              @focus="showInput = false"
            />
          </li>
          <li class="list-item">
            <div class="f-minor item-left">身份证号</div>
            <input
              v-if="!isTFY"
              type="text"
              class="ipt-inline person-input"
              :class="showInput == false ? 'person-hiden' : 'person-show'"
              id="person-input-card"
              style="background: #fff"
              v-model="certNo"
              placeholder="请输入身份证号码"
              maxlength="20"
              @focus="
                showInput = true;
                certNo = saveInfo.certNo;
              "
            />
            <input
              v-else
              type="text"
              class="ipt-inline person-input"
              :class="showInput == false ? 'person-hiden' : 'person-show'"
              id="person-input-card"
              style="background: #fff"
              v-model="certNo"
              placeholder="请输入身份证号码"
              maxlength="20"
              readonly
              @focus="showInput = false"
            />
          </li>
          <li
            class="arr-item list-item person-click-phone"
            @click="goModifyPhone"
          >
            <div class="f-minor item-left">手机号码</div>
            <span style="float: right" class="f-minor">{{
              userInfo.mobileNo | dotted
            }}</span>
          </li>
        </ul>
        <div class="logo-out" v-show="!showInput">
          <button
            id="logout"
            class="logout"
            @click="logout()"
            type="button"
            v-show="!isTFY"
          >
            退出登录
          </button>
        </div>
      </scroll>
      <footer class="save-btn">
        <button
          v-show="showInput"
          id="person-input-save"
          type="submit"
          class="btn-complete"
        >
          保 存
        </button>
      </footer>
    </form>
    <confirm
      text="确认退出登录？"
      v-model="showConfirm"
      @on-sure="doLogoutRequest"
    ></confirm>
    <confirm
      title="保存提示"
      text="信息未保存，请先点确定保存"
      v-model="showMessage"
      @on-cancel="cancelsave"
      @on-sure="saveUserInfo"
    ></confirm>
  </div>
</template>
<script>
import personal from 'personal.service'
import Confirm from 'Confirm'
import settings from 'settings.service'

const check = function (personalForm) {
  var userName = personalForm.saveInfo.name;
  var cardNo = personalForm.certNo;
  if (userName === null || userName.trim().length === 0) {
    return '输入姓名不能为空';
  }
  //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  if (cardNo === null || cardNo.length === 0) {
    return '身份证号不能为空';
  }
  if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(cardNo.toUpperCase()))) {
    return '身份证号输入有误';
  }
}

export default {

  components: {
    Confirm,
  },
  data () {
    return {
      scrollId: 'personal-scroll',
      userInfo: {
        name: '',
        certNo: '',
      },
      saveInfo: {
        name: '',
        certNo: '',
      },
      popupActive: false,
      showConfirm: false,
      showInput: false,
      showMessage: false,
      focusInput: {
        ID: '',
      },
      certNo: '',
    }
  },
  created () {
    this.refresh();
  },
  computed: {
    isTFY() {
      return localStorage.channel === 'TFY' || localStorage.channel === 'TFTB' || localStorage.channel === 'TFRYB'
    }
  },
  methods: {
    refresh () {
      personal.getUserInfo().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg)
          return
        }
        this.userInfo = res.data
        this.saveInfo.name = res.data.name;
        this.saveInfo.certNo = res.data.certNo;
        if (res.data.certNo !== '') {
          let certNo = res.data.certNo;
          this.certNo = certNo.substr(0, 4) + '*****' + certNo.substr(14)
        }
      })
    },
    goModifyPhone () {
      //判断是否为天府云渠道
      if (this.isTFY) {
        return;
      }
      this.$router.push('ModifyPhone')
    },
    logout () {
      this.showConfirm = true;
    },
    //退出登陆接口
    doLogoutRequest () {
      settings.logout().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        localStorage.removeItem('tokenId');
        sessionStorage.removeItem('tokenId');
        localStorage.removeItem('mobileNo');
        const redirect_uri = location.origin + PUBLIC_PATH + "login"
        //保证用户登录的情况获取最新code
        const codeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa2010bbda773d503&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect'
        window.location.replace(codeUrl)
      })
    },
    //保存修改信息
    saveUserInfo () {
      var checkMsg = check(this)
      if (checkMsg) {
        return this.$utils.alert(checkMsg);
      }
      this.saveInfo.certNo = this.certNo
      this.userInfo.name = this.saveInfo.name
      this.userInfo.certNo = this.saveInfo.certNo
      //调用修改个人信息接口
      personal.editUserInfo(this.saveInfo).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg)
          return
        }
        this.$router.back()
        // this.$router.replace('profile');
      })
    },
    //返回个人中心
    cancelsave () {
      this.userInfo.name = this.saveInfo.name
      this.userInfo.certNo = this.saveInfo.certNo
      this.$router.back()
    },
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    if (this.userInfo.name !== this.saveInfo.name || this.userInfo.certNo !== this.saveInfo.certNo) {
      this.showMessage = true;
      next(false);
    } else {
      next();
    }
  },
}

</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";

.list-personal {
  .item-left {
    width: 30%;
    display: inline-block;
  }
  .person-input {
    float: right;
    width: 70%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .person-hiden {
    text-align: right;
    color: #999999;
  }
  .person-show {
    text-align: right;
    color: #333;
  }
}

.ipt-inline {
  border: none;
  font-size: 0.35rem;
}

.logout {
  width: 100%;
  height: 1.5rem;
  margin-top: 10px;
  background-color: #ffffff;
  color: #fd0303;
}

.save-btn {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// Personal.vue?d77b1fba